<template>
  <footer class="zmm-footer">
    <div class="default-container">

      <div class="zmm-footer__flex">
        <div>
          <img :src="require('@/assets/components/ZmmFooter/logo-footer-new.png')" alt="Diamant Compositi Logo" width="291px" height="73px">
        </div>
        <div>

          <p v-html="$t('testoCompanyFooter')" />
          <p v-html="$t('testoFooter')" />
          <p style="margin-top:1rem;">
            <router-link :to="{ name: `${lang}-condizioni-generali`, params: { lang } }">
              Privacy Policy
            </router-link> -
            <router-link :to="{ name: `${lang}-cookie-policy`, params: { lang } }">
              Cookie Policy
            </router-link>
          </p>
        </div>
        <div>
          <p><a href="https://www.quamm.it/" rel="noopener" target="_blank">quamm.it</a></p>
        </div>
      </div>

    </div>
  </footer>
</template>

<script>

export default {
  props: {
    lang: {
      type: String,
      required: true
    }
  }
}

</script>

<style lang="scss">
  @import "../assets/mixins/breakpoints";
  @import "../assets/mixins/typo";

  .zmm-footer{
    background-color: #000000;
    padding: 4rem 0 3rem;
    text-align: center;

    .zmm-footer__flex{
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      @media #{$large_mq} {
        flex-wrap: nowrap;
      }

      div{
        width: 100%;
        margin: 1rem 0;

        @media #{$large_mq} {
          width: auto;
          margin: 0 auto;

          &:first-child {
            margin-left: -10px;
          }
        }
      }
    }

    @media #{$large_mq} {
      padding: 4rem 0 4rem;
    }

    p{
      @include size-14-pixel(#9B9B9B);
      line-height: 1.5; text-transform: uppercase;
      margin: 0; font-weight: 500;
      font-family: 'Roboto', serif;
      text-align: center;
      @media #{$large_mq} {
        text-align: left;
      }
    }

    a{
      @include size-14-pixel(#9B9B9B);
      line-height: 1.5;
      text-decoration: none;
      display: inline-block;
      transition: all .4s linear;
      border-bottom: 1px solid #000000;
      font-weight: 500;
      font-family: 'Roboto', serif;
      text-transform: none;
    }

    a:hover{
      color: #EFEFF1;
      border-bottom: 1px solid #EFEFF1;
    }
  }
</style>
